import { Link } from "react-router-dom";
import preloadRoute from "../utils/preloadRoute";

const NavLink = ({ to, onMouseEnter, onFocus, ...props }) => {
  const prefetch = () => {
    if (typeof to === "string") {
      preloadRoute(to);
    }
  };

  return (
    <Link
      to={to}
      onMouseEnter={(event) => {
        prefetch();
        onMouseEnter?.(event);
      }}
      onFocus={(event) => {
        prefetch();
        onFocus?.(event);
      }}
      {...props}
    />
  );
};

export default NavLink;
